import ContentHeading from "@/components/content-heading";
import React from "react";
import {useTranslation} from "react-i18next";
import {videosWrapper} from "./style";
import VideoItems from "./video-items";

const Videos = () => {
    const {t} = useTranslation();
    return <section className={videosWrapper}>
        <ContentHeading h={"h3"}
                        className={"justify-center"}
                        backdropPosition={"left-4"}
                        color={"text-white"}
                        fontSize={"mobile:text-3xl tablet:text-5xl"}
                        background={"bg-primary bg-opacity-40"}>
            {t("media.video-section.heading")}
        </ContentHeading>
        <VideoItems/>
    </section>
}

export default Videos